export default __webpack_public_path__ + "static/media/Inter-Regular.e89cb199.ttf";